import { styled } from '@linaria/react';

export const SextingTextMessageWrapped = styled.div`
	text-shadow: 0 1px 7px var(--brand-common);
`;
